import { ModelSagres } from "@/types/model-sagres";
import { ContatosResponsavel } from "./contato-responsavel";
export class unidadeOrcamentaria extends ModelSagres {
    Id: number
    Nome: string
    Codigo: string
    Exercicio: number
    CodUgSagres: string
    ContatoUnidadeOrcamentaria: ContatosResponsavel

    constructor(obj?: any) {
        super()
        if (obj) {
            this.Id = obj.Id
            this.Nome = obj.Nome;
            this.Codigo = obj.Codigo;
            this.Exercicio = obj.Exercicio;
            this.CodUgSagres = obj.CodUgSagres;
            this.ContatoUnidadeOrcamentaria = new ContatosResponsavel(obj.ContatoUnidadeOrcamentaria[0])

        }
    }
}
